<div class="col-md-12 col-sm-12 col-xs-12" style="padding-bottom: 0px; padding: 15px 15px 5px;">
    <div class="row">
      <div class="col-md-4 col-sm-5 col-xs-4" style="display: inline-block;">
          <h4 style="display: inline-block; font-size: 18px;">Import BOM </h4>
      </div>
  
      <div class="col-md-8 col-sm-7 col-xs-8" style="display: inline-block;">
          <span>
              <i class="closeMdl zmdi zmdi-close brdrRadius3" style="float: right; margin-left: 5px; top: -5px;" (click)="closeModal('')"></i>
          </span>
  
          <span class="btn darkBlueButton fntSz" title="Important Notes" (click)="openModal(impNotes, 'fromInfo')"
              style="cursor: pointer; line-height: 18px; padding: 5px 11px !important; float: right; margin-right: 5px;">
              <span><i class="fa fa-info" aria-hidden="true"></i></span>
          </span>
          <span class="btn btn-orange brdrRadius3" style="float: right; line-height: unset;cursor: pointer; position: relative;font-size: 14px;padding: 2px 10px; box-shadow: none; margin-right: 5px;"> 
              <a href="assets/ExcelFiles/Biziverse - BOM Import Template.xlsx" style="text-decoration: none;">
                  <i class="zmdi zmdi-download" style="margin-right: 7px; line-height: 23px; font-size: 14px;"></i>Download Template
              </a>
          </span>
      </div>
    </div>
  </div>
  
  <div class="col-md-12 col-sm-12 col-xs-12" style="padding: 0px 15px;">
      <div class="btn darkBlueButton brdrRadius3" *ngIf="!error.showError" style="margin-top: 15px; margin-bottom: 10px; width: 100%; border-radius: 25px; padding: 7px 12px;cursor: pointer;line-height: 20px;" (click)="openModal(impNotes, 'fromUpload')">
          <input type="file" id="input" (change)="onFileChange($event)" style="display: none;" #ImportFile/>
          <i class="fa fa-arrow-up"></i>
          <span style="margin-left: 10px; font-size: 14px;">Import Items from Excel</span>
      </div>
  </div>
  <div style="padding-bottom: 7px;" *ngIf="!error.showError">
  </div>
  
  <!--Import Items Table-->
  <div class="col-md-12 col-sm-12 col-xs-12" *ngIf="error.showError" style="margin-bottom: 15px;">
    <div class="row" style="margin: 0px;">
        <!-- WebView -->
        <div class="col-md-12" style="padding: 0px;">
            <div style="background-color: #fff; max-height: 280px; overflow-y: auto" *ngIf="data.length > 0">
                <table class="table table-bordered" style="margin-bottom: 0px;">
                    <thead>
                        <tr style="font-size: 12px;">
                            <th style="width: 1%; border-bottom: 0px;">No.</th>
                            <th style="width: 10%; border-bottom: 0px;">Item Name</th>
                            <th style="width: 20%; border-bottom: 0px;">Error</th>
                        </tr>
                    </thead>
                    <tbody>
                  
                        <tr *ngFor="let i of itemList" style="font-size: 12px;">
                            <td style="text-align: right;">{{i.srNo}}</td>
                            <td>{{i.itemName}}</td>
                            <td class="redText">
                               <span style="vertical-align: middle;">{{i.msg}}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div style="margin-top: 10px;" *ngIf="error.showError && error.apiResponse == false && itemList.length != data.length">
                <label style="font-weight: 500; cursor: pointer; font-size: 13px !important; width: 100%; margin-bottom: 0px;">
                    <input type="checkbox" [(ngModel)]="error.removeError" class="chkbox-darkblue" style="vertical-align: middle; margin-right: 3px; color: #dee2e6;"/> Ignore items with errors - import other items
                </label>
                <span class="btn btn-darkGreen" *ngIf="error.removeError" (click)="importItems()"
                  style="padding: 3px 8px; border-radius: 3px;line-height: inherit;font-size: 13px; margin-top: 5px;">
                    <i class="fa fa-check" style="padding-right: 7px;"></i>Save
                </span>
            </div>  
        </div>
    </div>
  </div>
  
  <!--Important Notes-->
  <ng-template #impNotes let-modal>
      <!--Header-->
      <div class="modal-header" style="border-bottom: none;">
          <div class="col-md-12 col-12 col-xs-12">
              <div class="row">
                  <div class="col-md-9 col-10 col-xs-10" style="padding-left: 0px;">
                      <h4 class="modal-title" style="font-size: 18px;"><span id="ApntmntHdr">{{impNotesTitle}}</span></h4>
                  </div>
                  <div class="col-md-3 col-2 col-xs-2" style="padding: 0px;">
                      <i class="closeMdl zmdi zmdi-close" style="float: right;" (click)="closeImpNotesModal('direct')" ></i>                       
                  </div>
              </div>              
          </div>
      </div>
      <!--Body-->
      <div class="modal-body" style="padding: 0px; font-size: 13px;">
          <div class="col-md-12" style="padding: 0px 15px 0px 15px;">
              <ol style="padding-left: 25px;">
                  <li>Please ensure that the <span class="orangeText">column names are not changed.</span></li>
                  <li>Compulsory fields <span class="orangeText"> (Item Name/Code, Qty)</span> must be included.</li>
                  <li>The maximum length for item name is <span class="orangeText">100 characters</span> and for item code is <span class="orangeText">50 characters</span>.</li>
                  <li>Item must be <span class="orangeText">pre-configured</span> in Biziverse account.</li>
              </ol>
              
          </div>
      </div>
      <!--Footer-->
      <div class="modal-footer col-md-12 col-sm-12 col-xs-12" style="border: none; justify-content: left !important; padding: 0px 15px 15px;">
          <span *ngIf="impNotesShowActBtn">
              <span class="btn darkGreenButton brdrRadius3" (click)="ImportFile2.click()" style="margin-right: 5px; padding: 4px 10px !important;">
                  <input type="file" id="input" (change)="onFileChange($event)" style="display: none;" #ImportFile2/>
                  <i class="zmdi zmdi-check" style="margin-right: 5px;"></i>
                  <span>Yes</span>
              </span>
              <span class="btn darkBlueButton brdrRadius3" (click)="closeImpNotesModal('alert')" style="margin-right: 5px; padding: 4px 10px !important;">
                  <i class="zmdi zmdi-close" style="margin-right: 5px;"></i>
                  <span>No</span>
              </span>
          </span>
  
          <span *ngIf="!impNotesShowActBtn" class="btn darkGreenButton brdrRadius3" (click)="closeImpNotesModal('direct')" style="margin-right: 5px; padding: 5px 16px !important;">              
              <i class="zmdi zmdi-check" style="margin-right: 5px;"></i>
              <span>Ok</span>
          </span>          
      </div>
  </ng-template>